/**
 * TonnieCheckedBadge Component
 *
 * Displays verified content badge with Tonnie branding.
 */

import { CheckCircle2 } from 'lucide-react';

import { cn } from '../lib/utils';
import { Badge } from '../primitives/badge';

export interface TonnieCheckedBadgeProps {
  /** Additional CSS classes */
  className?: string;
  /** Badge variant */
  variant?: 'default' | 'outline' | 'secondary';
  /** Badge size */
  size?: 'sm' | 'md' | 'lg';
  /** Show checkmark icon */
  showIcon?: boolean;
}

export function TonnieCheckedBadge({
  className,
  variant = 'default',
  size = 'sm',
  showIcon = true,
}: TonnieCheckedBadgeProps) {
  const sizeClasses = {
    sm: 'text-xs px-1.5 py-0.5',
    md: 'text-sm px-2 py-1',
    lg: 'text-base px-2.5 py-1.5',
  };

  return (
    <Badge
      variant={variant}
      className={cn(
        'bg-success/10 text-success-accessible border-success/20 font-medium',
        sizeClasses[size],
        className
      )}
    >
      {showIcon && <CheckCircle2 className="w-3 h-3 mr-1" />}
      Tonnie Checked
    </Badge>
  );
}
